import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const url = (config.url || "").replace(/^\//, "");
  // The Editorial -> AI handoff is a PUBLIC exchange. Never attach a stale/old/other-user
  // bearer to it: the handoff must be verified purely on its signed token, and only the
  // verified handoff user's session may be adopted afterwards.
  const isPublicHandoff = url.startsWith("auth/ez-handoff");
  const token = localStorage.getItem("pf_token");
  if (token && !isPublicHandoff) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
